import React from 'react';
import { ArrowLeft, Printer, ClipboardCheck } from 'lucide-react';

const PageHeaderProcesVerbal = ({ procesVerbal, navigate, handlePrint }) => {
  const getAllEtudiants = (soutenance) => {
    if (!soutenance) return [];
    
    const etudiants = [];
    
    if (soutenance.etudiants_soutenance && soutenance.etudiants_soutenance.length > 0) {
      soutenance.etudiants_soutenance.forEach(etudiantSoutenance => {
        if (etudiantSoutenance.etudiant) {
          etudiants.push(etudiantSoutenance.etudiant);
        }
      });
    } else if (soutenance.etudiant_principal_info) {
      etudiants.push(soutenance.etudiant_principal_info);
    }
    
    return etudiants;
  };

  const etudiants = getAllEtudiants(procesVerbal?.soutenance);

  return (
    <div className="bg-gradient-to-r from-[#202654] to-[#3a4999] text-white p-6 print:hidden">
      <div className="flex justify-between items-center">
        <div className="flex items-center gap-4">
          <ClipboardCheck className="h-8 w-8" />
          <div>
            <h1 className="text-2xl font-bold">Procès-verbal de soutenance</h1>
            <p className="text-blue-100">
              {etudiants.length > 0 ? 
                etudiants.map(e => `${e.nom} ${e.prenom}`).join(', ') : 
                'Soutenance'
              }
            </p>
            <p className="text-blue-200 text-sm">
              {procesVerbal?.soutenance?.sujet && `Sujet: ${procesVerbal.soutenance.sujet}`}
            </p>
          </div>
        </div>
        <div className="flex gap-3">
          <button
            onClick={handlePrint}
            className="px-4 py-2 bg-white/20 hover:bg-white/30 rounded-lg text-sm font-medium flex items-center gap-2 transition-colors"
          >
            <Printer className="h-4 w-4" />
            Imprimer
          </button>
          <button
            onClick={() => navigate('/soutenance')}
            className="px-4 py-2 bg-white/20 hover:bg-white/30 rounded-lg text-sm font-medium flex items-center gap-2 transition-colors"
          >
            <ArrowLeft className="h-4 w-4" />
            Retour
          </button>
        </div>
      </div>
    </div>
  );
};

export default PageHeaderProcesVerbal; 